import React from 'react';
import { Location } from "@reach/router";
import {TransitionGroup, Transition} from "react-transition-group"

// this timeout value must be equal to the transitionDelay value in gatsby-browser.js
const timeout = 400

const getTransitionStyles = {
    entering: {
        position:  `absolute`,
        opacity: 0,
    },
    entered: {
        transition: `all ${timeout}ms ease-in-out`,
        opacity: 1,
    },
    exiting: {
        transition: `all ${timeout}ms ease-in-out`,
        opacity: 0,
    }
}

const WayfxTransition = props => (
    <Location>
        {({ location }) => (
            <TransitionGroup>
                <Transition
                    key={location.key}
                    timeout={{
                        enter: timeout,
                        exit: timeout,
                    }}
                    >
                    {status => (
                    <div
                        className={`page-content ${status}`}
                        style={{
                            ...getTransitionStyles[status],
                        }}>
                        {props.children}
                    </div> 
                    )}
                </Transition>
            </TransitionGroup>
        )}
    </Location>
);
 
export default WayfxTransition;